import React, { useState } from "react";
import "./AlertProv.css";
import { TiDelete } from "react-icons/ti";

const AlertProv = () => {
  const [AlertProv, setAlertProv] = useState(true);

  const CloseAlert = () => {
    setAlertProv(false);
  };

  return (
    <>
      {AlertProv === true ? (
        <div className="boxalertprov">
          <p className="textalertprov">
            Te Pedimos por favor que cargues la factura de este mes
          </p>
          <TiDelete className="iconalertprov" onClick={CloseAlert} />
        </div>
      ) : null}
    </>
  );
};

export default AlertProv;
